<template>
  <div class="bg-gradient"></div>
  <div class="bg-texture"></div>
  <main class="container">
    <img src="@/assets/logo.png" alt="취준생 키우기 로고" class="logo" fetchpriority="high" decoding="async"/>
    <h1 class="title">취준생 키우기 사전예약 혜택 받기</h1>
    <p class="subtitle">
      스토어 사전등록 오픈 이전에 전작 <b>수험생 키우기</b>에서 번호를 통해 사전예약하신 분들을 위한 페이지입니다.<br/>
      아래 정보를 입력하면 <b>취준생 키우기</b> 우편함으로 보상이 지급됩니다.
    </p>

    <form class="card" @submit.prevent="submit">
      <div class="field">
        <label for="phone">사전예약 전화번호</label>
        <input
          id="phone" v-model="phone" type="tel" inputmode="tel" autocomplete="tel"
          placeholder="010-1234-5678" :disabled="done"
        />
      </div>
      <div class="field">
        <label for="prevNick">수험생 키우기(전작) 닉네임</label>
        <input
          id="prevNick" v-model="prevNick" type="text" autocomplete="off"
          placeholder="전작에서 쓰던 닉네임" :disabled="done"
        />
      </div>
      <div class="field">
        <label for="newNick">취준생 키우기(신작) 닉네임</label>
        <input
          id="newNick" v-model="newNick" type="text" autocomplete="off"
          placeholder="현재 게임 내 닉네임" :disabled="done"
        />
      </div>

      <button class="submit-btn" type="submit" :disabled="loading || done">
        {{ loading ? '확인 중…' : '보상 받기' }}
      </button>

      <p v-if="result" :class="['result', `result--${result.kind}`]">{{ result.text }}</p>
    </form>

    <footer class="footer">
      <p>
        회사명 : 바삭한소프트 | 주소 : 서울시 성동구 왕십리로 222, 한양대학교 코맥스스타트업타운 1층 유니콘룸 | 사업자등록번호 : 306-09-10281 <br/>
        통신판매업신고번호: 제 2024-서울성동-0973 호 | 문의 : contact@basakansoft.com
      </p>
    </footer>
  </main>
</template>

<script>
const ENDPOINT = 'https://asia-northeast3-get-job-f2e31.cloudfunctions.net/requestLegacyPreReward';

export default {
  name: 'PreRegRewardClaim',
  data() {
    return {
      phone: '',
      prevNick: '',
      newNick: '',
      loading: false,
      done: false, // 지급 완료 시 폼 잠금
      result: null, // { kind: 'success'|'info'|'error', text }
    };
  },
  methods: {
    submit() {
      if (this.loading || this.done) return;
      this.result = null;

      if (!this.phone.trim() || !this.prevNick.trim() || !this.newNick.trim()) {
        this.result = {kind: 'error', text: '전화번호, 전작 닉네임, 신작 닉네임을 모두 입력해주세요.'};
        return;
      }

      this.loading = true;
      // 운영은 release, ?env=dev 로 접속 시 dev (테스트용).
      const env = this.$route.query.env === 'dev' ? 'dev' : 'release';

      fetch(ENDPOINT, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          env,
          phone: this.phone.trim(),
          prevNick: this.prevNick.trim(),
          newNick: this.newNick.trim(),
        }),
      })
          .then((res) => res.json().catch(() => ({result: 'failed'})))
          .then((data) => this.applyResult(data))
          .catch(() => {
            this.result = {kind: 'error', text: '네트워크 오류가 발생했습니다. 연결을 확인하고 다시 시도해주세요.'};
          })
          .finally(() => {
            this.loading = false;
          });
    },
    applyResult(data) {
      const r = (data && data.result) || 'failed';
      const reason = data && data.reason;

      if (r === 'success') {
        this.done = true;
        this.result = {kind: 'success', text: '🎉 보상이 지급되었습니다! 게임 내 우편함에서 보상을 받아주세요.'};
        return;
      }
      if (r === 'already_paid') {
        this.done = true;
        this.result = {kind: 'info', text: '이미 보상을 받으셨습니다. 게임 내 우편함을 확인해주세요.'};
        return;
      }
      if (r === 'not_eligible') {
        this.result = {kind: 'error', text: '사전예약 명단에서 전화번호를 찾을 수 없습니다. 사전예약 시 입력하신 번호가 맞는지 확인해주세요.'};
        return;
      }
      if (r === 'nickname_mismatch') {
        if (reason === 'prev_nick') {
          this.result = {kind: 'error', text: '수험생 키우기(전작) 닉네임이 일치하지 않습니다. 다시 확인해주세요.'};
        } else if (reason === 'new_nick_not_found') {
          this.result = {kind: 'error', text: '입력하신 취준생 키우기(신작) 닉네임의 계정을 찾을 수 없습니다. 게임 내 닉네임을 정확히 입력해주세요.'};
        } else if (reason === 'new_nick_ambiguous') {
          this.result = {kind: 'error', text: '동일한 신작 닉네임이 여러 개 발견되어 자동 지급이 어렵습니다. contact@basakansoft.com 으로 문의해주세요.'};
        } else {
          this.result = {kind: 'error', text: '입력하신 정보가 일치하지 않습니다. 다시 확인해주세요.'};
        }
        return;
      }
      if (r === 'invalid_input') {
        this.result = {kind: 'error', text: '전화번호, 전작 닉네임, 신작 닉네임을 모두 입력해주세요.'};
        return;
      }
      this.result = {kind: 'error', text: '일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'};
    },
  },
};
</script>

<style scoped>
.bg-gradient {
  position: fixed;
  inset: 0;
  background: linear-gradient(180deg, #73C4FC 0%, #3AA0E7 100%);
  z-index: -2;
}

.bg-texture {
  position: fixed;
  inset: 0;
  background-image: url('@/assets/bg_texture2.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1;
  pointer-events: none;
}

.container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 40px 20px 130px;
  text-align: center;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.logo {
  width: 150px;
  margin-bottom: 20px;
  filter: drop-shadow(0 8px 22px rgba(15, 60, 110, 0.35));
}

.title {
  margin: 0 0 12px;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #ffffff;
  -webkit-text-stroke: 5px #0F4D88;
  paint-order: stroke fill;
  text-shadow: 0 6px 12px rgba(15, 60, 110, 0.35);
}

.subtitle {
  margin: 0 0 28px;
  font-size: 15px;
  line-height: 1.65;
  color: #ffffff;
  text-shadow: 0 2px 6px rgba(15, 60, 110, 0.35);
}

.subtitle b {
  font-weight: 800;
}

.card {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px 22px;
  box-shadow: 0 12px 30px rgba(15, 60, 110, 0.35);
  width: 100%;
  max-width: 420px;
}

.field {
  text-align: left;
  margin-bottom: 16px;
}

.field label {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #0F4D88;
  margin-bottom: 7px;
}

.field input {
  width: 100%;
  box-sizing: border-box;
  padding: 13px 14px;
  border: 2px solid #cfe6fa;
  border-radius: 12px;
  font-size: 15px;
  color: #13334f;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease;
}

.field input::placeholder {
  color: #9db8cf;
}

.field input:focus {
  border-color: #3AA0E7;
}

.field input:disabled {
  background: #f1f5f9;
  color: #7c93a8;
}

.submit-btn {
  width: 100%;
  margin-top: 6px;
  padding: 14px;
  border: none;
  border-radius: 14px;
  background: #0F4D88;
  color: #ffffff;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.1s ease;
}

.submit-btn:hover:not(:disabled) {
  background: #0c3e6e;
}

.submit-btn:active:not(:disabled) {
  transform: translateY(1px);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.result {
  margin: 16px 0 0;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.55;
  text-align: left;
}

.result--success {
  background: #e8f8ee;
  color: #137a3e;
}

.result--info {
  background: #eef4fb;
  color: #0F4D88;
}

.result--error {
  background: #fdecec;
  color: #c0392b;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px max(12px, env(safe-area-inset-left)) calc(12px + env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-right));
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  font-size: 11.5px;
  text-shadow: 0 1px 2px rgba(15, 60, 110, 0.35);
  pointer-events: none;
}

.footer p {
  margin: 0;
  pointer-events: auto;
}

@media (max-width: 600px) {
  .logo { width: 120px; }
  .title { font-size: 24px; }
  .subtitle { font-size: 14px; }
}
</style>
